export const userFarmDetail = () => {
  let userFarm = {};
  userFarm =
    JSON.parse(localStorage.getItem("userProfile")) &&
    JSON.parse(localStorage.getItem("userProfile")).farmResponseDTO;
  return {
    id: userFarm ? userFarm.id : "",
    farmId: userFarm ? userFarm.farmId : "",
    name: userFarm ? userFarm.farmName : "",
    size: userFarm ? userFarm.farmSize : "",
    farmAddress: userFarm ? userFarm.address : ""
  };
};



// WEBPACK FOOTER //
// ./src/config/farmDetails.js